module.exports = __webpack_public_path__ + "img/co2-eq.8456dd62.svg";